import { Component } from 'vue-property-decorator';
import { VueWizard } from '@/vue-wizard';
import { BASE_URL_MANAGER, BASE_URL_ORCHESTATOR } from '@/config';

@Component({
  name: 'agents-integration',
})
export default class AgentsIntegration extends VueWizard {}
